import { useHistory } from "react-router-dom";
import RxLink from "../RxLink";
import RxTypography from "../RxTypography";
import styles from "./RxFooter.module.css";

const RxFooter = () => {
	const history = useHistory();

	return (
		<div className={styles.mainDiv}>
			<RxTypography
				variant="body1"
				align="center"
				color="textPrimary"
				label={<>RxMediaPharma®</>}
				className={` ${styles.horizontalSpace} ${styles.trademarkRX}`}
			/>

			<RxTypography
				variant="body1"
				align="center"
				color="textPrimary"
				className={styles.pipes}
				label={<>|</>}
			/>

			<RxLink
				color={"primary"}
				label="Üyelik ve Gizlilik Sözleşmesi"
				className={styles.horizontalSpace}
				onClick={() => {
					history.push("/membership");
				}}
			/>

			<RxTypography
				variant="body1"
				align="center"
				color="textPrimary"
				className={styles.pipes}
				label={<>|</>}
			/>

			<RxLink
				color={"primary"}
				label="Mesafeli Satış Sözleşmesi"
				className={styles.horizontalSpace}
				onClick={() => {
					history.push("/sale-contract");
				}}
			/>

			<RxTypography
				variant="body1"
				align="center"
				color="textPrimary"
				className={styles.pipes}
				label={<>|</>}
			/>

			<RxLink
				color={"primary"}
				label="Güvenlik Politikası"
				className={styles.horizontalSpace}
				onClick={() => {
					history.push("/security-policy");
				}}
			/>

			<RxTypography
				variant="body1"
				align="center"
				color="textPrimary"
				className={styles.pipes}
				label={<>|</>}
			/>

			<RxLink
				color={"primary"}
				label="Kişisel Verilerin Korunması Kanunu (KVKK) Aydınlatma Metni"
				className={styles.horizontalSpace}
				onClick={() => {
					history.push("/kvkk");
				}}
			/>
		</div>
	);
};

export default RxFooter;
